import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=5b67ab62&scoped=true&"
import script from "./ClientTable.vue?vue&type=script&lang=ts&"
export * from "./ClientTable.vue?vue&type=script&lang=ts&"
import style0 from "./ClientTable.vue?vue&type=style&index=0&id=5b67ab62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b67ab62",
  null
  
)

export default component.exports